export function toOrdinal<T = object | string | number | undefined>(value: T): string | T {
    // if not a number or NaN, return the original value (passthrough)
    if (typeof value !== 'number' || isNaN(value)) {
        return value;
    }
    const absoluteValue = Math.abs(Math.floor(value));
    const lastTwoDigits = absoluteValue % 100;
    const lastDigit = absoluteValue % 10;
    const sign = value < 0 ? '-' : '';
    const finalValue = sign + absoluteValue;

    // 11, 12, 13 are special cases that always end with "th"
    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
        return `${finalValue}th`;
    }

    switch (lastDigit) {
        case 1:
            return `${finalValue}st`;
        case 2:
            return `${finalValue}nd`;
        case 3:
            return `${finalValue}rd`;
        default:
            return `${finalValue}th`;
    }
}
